import { render, staticRenderFns } from "./UserNavBar.vue?vue&type=template&id=6844b0a8&scoped=true&"
import script from "./UserNavBar.vue?vue&type=script&lang=js&"
export * from "./UserNavBar.vue?vue&type=script&lang=js&"
import style0 from "./UserNavBar.vue?vue&type=style&index=0&id=6844b0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844b0a8",
  null
  
)

export default component.exports